// extracted by mini-css-extract-plugin
module.exports = {"features-list":"_1410bfd27b--features-list--TWmcQ","feature-title":"_1410bfd27b--feature-title--Bf1yD"};